(function () {
  angular.module("akitabox.ui.directives.simpleAutocomplete", [
    "akitabox.core.toast",
  ]);
})();
